const mine = {
	namespaced: true,
	state: {
		orderNo: '' // 订单号
	},
	mutations: {
		updateOrderNo(state, payload) {
			state.orderNo = payload;
		},
	},
	actions: {

	}
}

export default mine



// WEBPACK FOOTER //
// ./src/store/mine.js